import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuComponent } from './menu/menu.component';

import { CoreModule } from './services/core.module';
import { ShareModule } from './share/share.module';
import { LoginScreenComponent } from './login-screen/login-screen.component';

import { TranslateLoader, TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslationComponent } from './translation/translation.component';
import { PuertoComponent } from './puerto/puerto.component';
import { GraficoPuertoComponent } from './grafico-puerto/grafico-puerto.component';

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    LoginScreenComponent,
    TranslationComponent,
    PuertoComponent,
    GraficoPuertoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ShareModule,
    CoreModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [ HttpClient ]
      }
    }),
    RouterModule.forRoot([
      {path: 'principal', loadChildren: './principal/principal.module#PrincipalModule'},
      {path: 'clima', loadChildren: './clima/clima.module#ClimaModule'},
      {path: 'agua', loadChildren: './agua-cloaca/agua-cloaca.module#AguaCloacaModule'},
      {path: 'energia', loadChildren: './energia/energia.module#EnergiaModule'},
      {path: 'cloacas', loadChildren: './agua-cloaca/agua-cloaca.module#AguaCloacaModule'},
      {path: 'luminarias', loadChildren: './agua-cloaca/agua-cloaca.module#AguaCloacaModule'},
      {path: 'sysdiags', loadChildren: './sysdiags/sysdiag.module#SysdiagModule'},
      {path: 'mantenimiento', loadChildren: './mantenimiento/mantenimiento.module#MantenimientoModule'},
      {path: 'login', loadChildren: './login/login.module#LoginModule'},
      {path: 'config-modulo-mqtt', loadChildren: './config-modulo-mqtt/config-modulo-mqtt.module#ConfigModuloMqttModule'},
      {path: 'seguridad-camaras', loadChildren: './seguridad-camaras/seguridad-camaras.module#SeguridadCamarasModule'},
      {path: 'auditoria', loadChildren: './auditoria/auditoria.module#AuditoriaModule'},
      {path: 'transito', loadChildren: './transito/transito.module#TransitoModule'},
      {path: 'sube', loadChildren: './sube/sube.module#SubeModule'},
      {path: 'stock', loadChildren: './control-de-stock/control-stock.module#ControlStockModule'},
      { path: 'puerto', component: PuertoComponent },

      {path: '**', loadChildren: './principal/principal.module#PrincipalModule'}
      


    ])
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
